import logoleft from "../../assets/logos/logo-left.png";
import logoright from "../../assets/logos/logo-right.png";
/**
 * Loads the header logo images as base64 data URIs for jsPDF's addImage.
 *
 * Default paths point at /assets/logos/logo-left.png and logo-right.png —
 * drop your real logo files in at those same paths (in your app's public/
 * or assets/ directory, whichever your build serves statically) and no
 * code change is needed. Pass different paths to loadLogosBase64() if you
 * name the files differently.
 *
 * RECOMMENDED SOURCE SIZE: logos render at 32×32pt in the PDF (32pt =
 * 0.444in). For crisp print output, export your logo at 300–320px square
 * (300dpi-equivalent) — a square PNG with transparency works best; jsPDF
 * scales it down to fit, so anything from ~150px up to ~600px square is
 * safe. Non-square logos will be squashed to fit the 32×32 slot, so pad
 * to a square canvas first if your logo isn't naturally square.
 */
export async function loadLogosBase64(
  leftUrl = logoleft,
  rightUrl = logoright,
): Promise<{ left: string; right: string }> {
  const toDataUri = async (url: string): Promise<string> => {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Failed to load logo at ${url}: HTTP ${res.status}`);
    const blob = await res.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const [left, right] = await Promise.all([toDataUri(leftUrl), toDataUri(rightUrl)]);
  return { left, right };
}